import type {PaymentApiModel} from '../../../api/payment';
import type {Nullable} from '../../utility-types';

export const isPaymentFailed = (payment?: Nullable<PaymentApiModel>) => {
  if (!payment) {
    return false;
  }

  /**
   * Failed status means that attempt charge was failed
   * but the backend will try to perform it again
   *
   * Frozen is a permanently failed status
   */
  return (['failed', 'frozen'] as PaymentApiModel['status'][]).includes(
    payment.status,
  );
};
